import { BankFilled } from '@ant-design/icons';
import { Alert, Tooltip } from 'antd';
import React, { useState } from 'react';
import {
	AiFillCheckCircle,
	AiFillFolderOpen,
	AiOutlineCreditCard,
	AiOutlineDollar,
	AiOutlineQuestionCircle,
	AiOutlineSwap,
	AiOutlineTeam,
	AiOutlineUser,
	AiTwotoneContainer
} from 'react-icons/ai';
import { GiSandsOfTime } from 'react-icons/gi';
import { Link, useLocation } from 'react-router-dom';
import { SBAvatar, SidebarCompanyName } from '../components/dashboard/styles';
import TASideBar from '../components/dashboard/ta-sidebar/ta-sidebar';
import Navbar from '../components/navigation/navbar/navbar';
import { useAuth } from '../contexts/authentication.context';
import { Role } from '../enums';
import { useMedia } from '../hooks/media.hook';
import authService from '../services/auth.service';
import configProxy from '../utils/config';
import { useTheme } from 'styled-components';

export const CompleteLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [matchModalVisible, setMatchModalVisible] = useState(false);
	const [sidbarVisible, setSidbarVisibility] = useState(false);
	const [inviteModalVisible, setInviteModalVisible] = useState(false);
	const theme = useTheme();
	const closeHandler = () => {
		setSidbarVisibility(false);
	};
	const { user, tempAccess } = useAuth();
	let media = configProxy.defaultExpandScreenSize;
	let desktopView = useMedia(media);
	const resource = useLocation().pathname;
	const menuItems = [
		{
			name: 'Company',
			icon: <AiTwotoneContainer />,
			key: `company`,
			submenu: [
				{ name: 'Company Profile', icon: <AiOutlineUser />, key: 'profile' },
				{ name: 'Team Members', icon: <AiOutlineTeam />, key: 'team' }
			]
		},
		{ name: 'Job Posts', icon: <AiFillFolderOpen />, key: 'jobs' },
		{
			name: 'Job Board',
			icon: <AiOutlineSwap />,
			key: 'job-board'
		},
		...(authService.hasRoles(Role.COMPANY_OWNER, Role.COMPANY_ADMIN)
			? [{ name: 'Offers', icon: <AiOutlineDollar />, key: 'offers' }]
			: []),
		{ name: 'Payment Details', icon: <AiOutlineCreditCard />, key: 'payment-details' }
		// { name: 'FAQ', icon: <AiOutlineQuestionCircle />, key: 'FAQ' }
	];

	const openHandler = () => {
		setSidbarVisibility(true);
	};
	return (
		<>
			<Navbar isAuthenticated={authService.isAuthenticated()} onBurgerClick={openHandler} />
			<TASideBar
				menuItems={menuItems}
				selected={resource}
				visible={sidbarVisible}
				close={closeHandler}
				collapseOnRouteChange
				header={collapsed => (
					<Link
						to="/dashboard/company/profile"
						className="w-100 d-flex flex-column align-items-center justify-content-center mt-4"
					>
						<Tooltip title={collapsed && user.company.name} placement="right">
							<SBAvatar
								className={collapsed && 'lg'}
								size={collapsed ? 60 : 120}
								src={(user.company && user.company.logo) || null}
								icon={<BankFilled />}
								shape="square"
							/>
						</Tooltip>
						<SidebarCompanyName className={!collapsed ? 'visible' : undefined}>
							{user.company.name}{' '}
							{user.company.verified ? (
								<AiFillCheckCircle color={theme.TA_GREEN_BLUE} />
							) : (
								<GiSandsOfTime color={theme.TA_WARNING} />
							)}
						</SidebarCompanyName>
					</Link>
				)}
			/>
			{tempAccess ? (
				<Alert
					message="You're temporarily accessing this company account. Please be careful!"
					type="warning"
					showIcon
				/>
			) : null}
			<div style={{ marginLeft: `${desktopView ? '80px' : '0'}`, overflowX: 'hidden' }}>{children}</div>
		</>
	);
};
